import {
    GET_USERS_ERROR,
    GET_USERS_START,
    GET_USERS_SUCCESS,
} from '../../actions/actionTypes';
import initialState from '../initialState';

export default (state = initialState.user.list, action = {type: ''}) => {
    switch (action.type) {
        case GET_USERS_START:
            return {
                ...state,
                error: false,
                loading: true,
            };
        case GET_USERS_SUCCESS:
            return {
                ...state,
                data: action.payload,
                loading: false,
            };
        case GET_USERS_ERROR:
            return {
                ...state,
                error: true,
                loading: false,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/userReducer/getUsersReducer.js